export default __webpack_public_path__ + "images/e662b603e159f90a9570c44109ebdee4.svg";